import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectedElementsActions from '../../../actions/selectedElements';
import MultipleElementsSetting from './MultipleElementsSetting/MultipleElementsSetting';
import ImageSetting from './ImageSetting/ImageSetting';
import ParagraphSetting from './ParagraphSetting/ParagraphSetting';
import ButtonSetting from './ButtonSetting/ButtonSetting';
import SpacerSetting from './SpacerSetting/SpacerSetting';
import SocialSetting from './SocialSetting/SocialSetting';
import SurveySetting from './SurveySetting/SurveySetting';
import VideoSetting from './VideoSetting/VideoSetting';
import * as Styled from './styles';
import { blockType } from '../../../types';
import elementTypes from '../../../constants/elementTypes';

class ElementSetting extends PureComponent {
    state = {
        selectedElementData: null,
        multipleElementsSelected: false,
        noElementsAreSelected: true,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { canvasBlocks, selectedElements } = nextProps;
        if (!canvasBlocks || !selectedElements || Object.keys(selectedElements.local).length === 0) {
            nextProps.dispatch(selectedElementsActions.removeAllSelectedElements());
            return { ...prevState, noElementsAreSelected: true };
        }
        const elmIdx = Object.keys(selectedElements.local)[0];
        const data = selectedElements.local[elmIdx];
        const { blockIndex, columnIdx } = data;
        const blockContainingElement = canvasBlocks.find((block) => block.index === blockIndex);
        const columnContainingElement =
            blockContainingElement &&
            Object.keys(blockContainingElement).length > 0 &&
            blockContainingElement.content.columns.find((column) => column.columnIdx === columnIdx);
        const selectedElement =
            columnContainingElement &&
            Object.keys(columnContainingElement).length > 0 &&
            columnContainingElement.columnItems.find((elm) => elm.elmIdx === elmIdx);

        if (!selectedElement || selectedElement.length === 0) {
            return {
                ...prevState,
                canvasIsEmpty: canvasBlocks.length === 0,
                selectedElementData: null,
                multipleElementsSelected: Object.keys(selectedElements.local).length > 1,
                noElementsAreSelected: true,
            };
        }

        const { content, type } = selectedElement;
        const selectedElementData = { blockIndex, columnIdx, elmIdx, content, type };

        return {
            ...prevState,
            selectedElementData,
            multipleElementsSelected: Object.keys(selectedElements.local).length > 1,
            noElementsAreSelected: false,
        };
    }

    render() {
        const { selectedElementData, multipleElementsSelected, noElementsAreSelected } = this.state;
        if (noElementsAreSelected || !selectedElementData) {
            return null;
        }

        const header = (name) => (
            <div style={{ position: 'relative' }}>
                <h2
                    style={{
                        display: 'inline-block',
                        fontSize: 12,
                        letterSpacing: 1,
                        fontWeight: 600,
                        color: '#535454',
                        textTransform: 'uppercase',
                    }}
                >
                    {name} SETTINGS
                </h2>
            </div>
        );

        if (multipleElementsSelected) {
            return (
                <Styled.DivWrapper>
                    {header('Multiple Elements')}
                    <Styled.InnerDiv>
                        <MultipleElementsSetting />
                    </Styled.InnerDiv>
                </Styled.DivWrapper>
            );
        }

        switch (selectedElementData.type) {
            case elementTypes.IMAGE:
                return (
                    <Styled.DivWrapper>
                        {header('IMAGE')}
                        <Styled.InnerDiv>
                            <ImageSetting selectedElementData={selectedElementData} />
                        </Styled.InnerDiv>
                    </Styled.DivWrapper>
                );
            case elementTypes.PARAGRAPH:
                return (
                    <Styled.DivWrapper>
                        {header('TEXT')}
                        <Styled.InnerDiv>
                            <ParagraphSetting selectedElementData={selectedElementData} />
                        </Styled.InnerDiv>
                    </Styled.DivWrapper>
                );
            case elementTypes.BUTTON:
                return (
                    <Styled.DivWrapper>
                        {header('BUTTON')}
                        <Styled.InnerDiv>
                            <ButtonSetting selectedElementData={selectedElementData} />
                        </Styled.InnerDiv>
                    </Styled.DivWrapper>
                );
            case elementTypes.SPACER:
                return (
                    <Styled.DivWrapper>
                        {header('SPACER')}
                        <Styled.InnerDiv>
                            <SpacerSetting selectedElementData={selectedElementData} />
                        </Styled.InnerDiv>
                    </Styled.DivWrapper>
                );
            case elementTypes.SOCIAL:
                return (
                    <Styled.DivWrapper>
                        {header('SOCIAL ICONS')}
                        <Styled.InnerDiv>
                            <SocialSetting selectedElementData={selectedElementData} />
                        </Styled.InnerDiv>
                    </Styled.DivWrapper>
                );
            case elementTypes.SURVEY:
                return (
                    <Styled.DivWrapper>
                        {header('SURVEY')}
                        <Styled.InnerDiv>
                            <SurveySetting selectedElementData={selectedElementData} />
                        </Styled.InnerDiv>
                    </Styled.DivWrapper>
                );
            case elementTypes.VIDEO:
                return (
                    <Styled.DivWrapper>
                        {header('VIDEO')}
                        <Styled.InnerDiv>
                            <VideoSetting selectedElementData={selectedElementData} />
                        </Styled.InnerDiv>
                    </Styled.DivWrapper>
                );
            default:
                return null;
        }
    }
}

ElementSetting.propTypes = {
    dispatch: PropTypes.func.isRequired,
    canvasBlocks: PropTypes.arrayOf(blockType).isRequired,
    selectedElements: PropTypes.shape({
        local: PropTypes.object,
        remote: PropTypes.object,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    canvasBlocks: state.canvasBlocks.present,
    selectedElements: state.selectedElements,
});

export default connect(mapStateToProps)(ElementSetting);
